var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4C9.79086 4 8 5.79086 8 8V9.2C8 10.6022 7.5227 11.9627 6.64646 13.0574L5.4682 14.5303C5.04687 15.0569 5.42195 15.84 6.09626 15.84H17.9037C18.578 15.84 18.9531 15.0569 18.5318 14.5303L17.3535 13.0574C16.4773 11.9627 16 10.6022 16 9.2V8C16 5.79086 14.2091 4 12 4Z",
    stroke: "#5F4A44",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 17.2C9.88 18.24 10.86 19 12 19C13.14 19 14.12 18.24 14.5 17.2",
    stroke: "#5F4A44",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIcon);
export default __webpack_public_path__ + "static/media/bell-icon.dc7087f6bcaed22e0a6d6b48804ba5e9.svg";
export { ForwardRef as ReactComponent };